<template>
    <div>
        <Swiper v-bind="swiperProps" class="polaroids">
            <SwiperSlide v-for="(item, index) in meta" :key="`polaroid-${index}`" class="polaroid-slide w-50 md:w-67.5 py-7 md:py-10 select-none" :lazy="true">
                <div class="polaroid h-62.5 w-50 px-2.75 pt-3.5 md:h-82.5 md:w-67.5 md:px-3.75 md:pt-4.75 bg-white">
                    <img :src="item.image.medium" :alt="`${item.concept.name} restaurant external photo`" class="aspect-square w-full object-cover" loading="lazy" />

                    <div class="font-filmotype text-lg md:text-2xl mt-5 md:mt-7 truncate">{{ item.concept.name }}</div>
                </div>
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script setup>
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

defineProps({ meta: { type: Array, required: true } });

const swiperProps = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    lazy: true,
    lazyPreloadPrevNext: 1,
    breakpoints: {
        768: { spaceBetween: 24 },
    },
    loop: true,
    modules: [Autoplay],
    speed: 15000,
    autoplay: {
        enabled: true,
        delay: 1,
        disableOnInteraction: false,
        reverseDirection: true,
    },
};
</script>

<style>
.polaroids .swiper-wrapper {
    transition-timing-function: linear;
}

.polaroids .swiper-slide {
    width: fit-content;
}

.polaroids .polaroid {
    box-shadow: 0 0 0.6875rem rgba(0, 0, 0, 0.1);
}

.polaroids .polaroid-slide[data-swiper-slide-index='2'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='6'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='10'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='14'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='18'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='22'] .polaroid {
    transform: rotate(4.5deg);
}

.polaroids .polaroid-slide[data-swiper-slide-index='0'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='4'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='8'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='12'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='16'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='20'] .polaroid,
.polaroids .polaroid-slide[data-swiper-slide-index='24'] .polaroid {
    transform: rotate(-4.5deg);
}
</style>
